import { AbstractControl } from '@angular/forms';
import { parsePhoneNumberFromString } from 'libphonenumber-js';
import { ValidatorMessageModel } from '../validator-message.model';

export class PhoneValidators {
  static invalidPhone(control: AbstractControl): {
    [key: string]: ValidatorMessageModel;
  } | null {
    const value = control.value;

    if (value === null || value === undefined || value === '') {
      return null;
    }

    const parsed = parsePhoneNumberFromString(`${value}`);

    return parsed?.isValid()
      ? null
      : {
          invalidPhone: new ValidatorMessageModel(
            'validators.phone.invalidPhone',
          ),
        };
  }
}
